import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToId } from "../utils/scroll";

const ScrollManager = () => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash?.replace("#", "");
    const fromState = location.state?.scrollTo;

    if (hash || fromState) {
      const id = hash || fromState;
      const timer = window.setTimeout(() => scrollToId(id), 80);
      return () => window.clearTimeout(timer);
    }

    window.scrollTo(0, 0);
    return undefined;
  }, [location.pathname, location.hash, location.state]);

  return null;
};

export default ScrollManager;
